import React, { useCallback } from 'react';
import type { IconName } from '@goodfynd/ui';
import { Icon } from '@goodfynd/ui';
import { Text } from '@goodfynd/ui';

import { StyledContainer } from './styles';
import type { AlertProps } from './types';
const getIcon = (type: AlertProps['type']): IconName => {
  switch (type) {
    case 'error':
      return 'caution';

    case 'info':
      return 'info';

    case 'success':
      return 'check';

    case 'warning':
      return 'caution_alt';

    case undefined:
    default:
      return 'chevron_right';
  }
};
export default function Alert({
  children,
  css,
  showIcon = true,
  type = 'info',
  ...props
}: AlertProps) {
  const renderContent = useCallback(() => {
    if (showIcon) {
      return (
        <Icon {...props} label={children} name={props.icon || getIcon(type)} />
      );
    }

    if (
      typeof children === 'string' ||
      (Array.isArray(children) && typeof children[0] === 'string')
    ) {
      return (
        <Text as="body2" inherit>
          {children}
        </Text>
      );
    }

    return children;
  }, [showIcon, children, props, type]);

  return (
    <StyledContainer {...props} css={css} type={type}>
      {renderContent()}
    </StyledContainer>
  );
}
